<template>
<div>
  <div    v-bind ='[{id:data.id}]'   class="page_list_row clearfloat  "   >
  <div class="gpage_photo"><img     v-bind ='{src:data.photo_100}'    />   </div>
  <div class="gpage_info  ">
  <div class="glabeled_name"  > <a v-bind ='{href: "https://vk.com/club"+data.id}' target="_blank"  style="text-decoration:none; color:#42648b;">  <span >{{data.name.substring( 28,-1).toLowerCase()}}</span> <v-tooltip bottom  v-if="data.name.length >28"  max-width="320"> <span slot="activator">...</span><span>{{data.name}}</span></v-tooltip> </a>  </div>
  <div class="glabeled selectable"   > </div>
  <div   class="glabeled selectable" > Подписчики: {{data.members_count}} </div>
  </div>
  <div class="gfunctions">

<v-tooltip bottom   open-delay="2000" max-width="200"  :disabled="data.add_info.added" >
<v-btn  slot="activator" block  small :loading="adding"  :disabled="data.add_info.added" color="#4A76A8" small class="white--text"  @click="addGroups(data.id, data)">Добавить</v-btn>
<span>После того как группа будет добавлена Вы сможете остлеживать новых подписчиков в разделе АКТИВНОСТЬ</span>
</v-tooltip>

 </div>

  </div>
  </div>
</div>
</template>




<script>
import axios from 'axios'
export default {
props: ['data','index', 'groups'],
 data: function(){
  return {
   adding: false
  }
},



methods: {
  addGroups:function(add_list, data){
    this.adding = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_add.php', {
         method: 'POST', data: {list: add_list}
       }).then(response => {
         this.adding = false
        data.add_info.added =  true
            console.log(response.data)

       })
  },


}
}
</script>

<style>
.clearfloat:after {
 content: "";
 display: table;
 clear: both;
}

.page_list_row_selected{
background-color : #EDF0F5;
border-radius : 7px
}



.page_list_row {

  margin: 15px;


  }

.page_list_row:hover {
  margin: 15px;
  border-radius:5px;
  cursor: pointer;
  }

.page_list_row .gpage_info  {

 padding-top: 10px;
 float: left;
   margin-bottom: 5px;
 margin-right: 25px;
   overflow: hidden;

   width: 250px;
 height: 80px;
}

.page_list_row .gpage_info .glabeled_name{


    margin-bottom: 5px;
  color: #42648b;
    font-weight: 700;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;

}
.page_list_row .gpage_info .glabeled_name:first-letter{
   text-transform: capitalize;
}




.page_list_row .glabeled {

   color: #656565;
}


.page_list_row .gfunctions {
   padding: 7px 0 0;
 position: relative;
   overflow: hidden;
   width: 150px;
   height: 80px;
 }




.page_list_row .gpage_photo {


   float: left;
   margin: 3px;
   margin-right: 9px;
   position: relative;
   width: 80px;
   height: 80px;
   overflow: hidden;
}

.page_list_row .gpage_photo img {


   width: 80px;
   height: 80px;
   border-radius: 50%;
   -moz-force-broken-image-icon: 0;
   background-color: #fafbfc;
}


</style>
